'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _auth = require('redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterpriseHeader = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(EnterpriseHeader, _Component);

  function EnterpriseHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EnterpriseHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnterpriseHeader.__proto__ || (0, _getPrototypeOf2.default)(EnterpriseHeader)).call.apply(_ref, [this].concat(args))), _this), _this._logout = function () {
      // if (this.props.logout) this.props.logout();
      window.location = process.env.LOGOUT_REDIRECT_URL;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EnterpriseHeader, [{
    key: '_renderUser',
    value: function _renderUser() {
      var _props = this.props,
          token = _props.token,
          isAuthenticated = _props.isAuthenticated;

      var styles = require('./EnterpriseHeader.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.user },
        (isAuthenticated && token || null) && _react2.default.createElement(
          'span',
          { className: styles.user__name },
          token.username
        ),
        (isAuthenticated && token || null) && _react2.default.createElement(
          'span',
          { className: styles.user__separator },
          ' | '
        ),
        isAuthenticated && token && _react2.default.createElement(
          'a',
          { className: styles.user__logOut, onClick: this._logout },
          'LOG OUT'
        )
      );
    }
  }, {
    key: '_renderLogo',
    value: function _renderLogo() {
      var _props2 = this.props,
          logo = _props2.logo,
          homeUrl = _props2.homeUrl;

      var styles = require('./EnterpriseHeader.scss');

      var logoImg = _react2.default.createElement('img', { className: styles.logo, src: logo, alt: 'Travelport - Redefining travel commerce' });

      if (homeUrl) {
        logoImg = _react2.default.createElement(
          'a',
          { className: styles.logoAnchor, href: homeUrl },
          logoImg
        );
      }

      return logoImg;
    }
  }, {
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var styles = require('./EnterpriseHeader.scss');

      return _react2.default.createElement(
        'header',
        { className: (0, _classnames2.default)(className, styles.root) },
        this._renderUser(),
        _react2.default.createElement(
          'div',
          { className: styles.brand },
          this._renderLogo(),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'strong',
              { className: styles.title__company },
              'Travelport'
            ),
            ' ',
            _react2.default.createElement(
              'span',
              { className: styles.title__project },
              'Trip Quotes'
            )
          )
        )
      );
    }
  }]);
  return EnterpriseHeader;
}(_react.Component), _class.propTypes = {
  isAuthenticated: _react.PropTypes.bool,
  token: _react.PropTypes.object,
  logo: _react.PropTypes.string,
  user: _react.PropTypes.object, // TODO
  homeUrl: _react.PropTypes.string,
  className: _react.PropTypes.string,
  logout: _react.PropTypes.func
}, _class.defaultProps = {
  user: { username: 'Mocked username' } // TODO: Remove this, it should be taken from the JWT
}, _temp2);


var mapStateToProps = function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    token: state.auth.token
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
  logout: _auth.logout.base
})(EnterpriseHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseHeader/EnterpriseHeader.jsx
// module id = 1590
// module chunks = 0